/** Booking page meta (mirrors booking.py). */

const DATE_RE = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;

export function parseBookingPageMeta(raw) {
  if (!raw) return {};
  if (typeof raw === 'object') return { ...raw };
  try {
    const data = JSON.parse(raw);
    return data && typeof data === 'object' ? data : {};
  } catch {
    return {};
  }
}

export function parseBookingDateString(value) {
  const m = DATE_RE.exec(String(value || '').trim());
  if (!m) return null;
  const day = parseInt(m[1], 10);
  const month = parseInt(m[2], 10);
  const year = parseInt(m[3], 10);
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year
    || date.getMonth() !== month - 1
    || date.getDate() !== day
  ) {
    return null;
  }
  date.setHours(0, 0, 0, 0);
  return date;
}

function hashPageCode(code) {
  let h = 0;
  const s = (code || '').toUpperCase();
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 33 + s.charCodeAt(i)) >>> 0;
  }
  return h;
}

function fallbackBookingDates(pageCode) {
  const seed = hashPageCode(pageCode);
  const checkIn = new Date();
  checkIn.setHours(0, 0, 0, 0);
  checkIn.setDate(checkIn.getDate() + 7 + (seed % 14));
  const checkOut = new Date(checkIn);
  checkOut.setDate(checkOut.getDate() + 28 + (seed % 10));
  return { checkIn, checkOut };
}

export function resolveBookingDates({ pageMeta, pageCode }) {
  const meta = parseBookingPageMeta(pageMeta);
  const checkIn = parseBookingDateString(meta.check_in);
  const checkOut = parseBookingDateString(meta.check_out);
  if (checkIn && checkOut) {
    return { checkIn, checkOut };
  }
  return fallbackBookingDates(pageCode || 'X');
}
